import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getRoomInfo, RoomInfoDto, RoomInfoRequest } from 'src/api/roomService';

import { queryRetry } from '../query-retry';

type UseFetchRoomInfoOptions = RoomInfoRequest & {
    enabled?: boolean;
};

export const useFetchRoomInfo = ({
    developmentSlug,
    roomCode,
    academicYear,
    moveInDate,
    duration,
    enabled = true,
}: UseFetchRoomInfoOptions) =>
    useQuery<RoomInfoDto, AxiosError>({
        enabled: enabled && Boolean(roomCode && academicYear && moveInDate && duration > 0),
        queryKey: ['roomInfo', developmentSlug, roomCode, academicYear, moveInDate, duration],
        queryFn: () =>
            getRoomInfo({ developmentSlug, roomCode, academicYear, moveInDate, duration }),
        retry: queryRetry,
        staleTime: Infinity,
    });
